import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import AppDrawer, { IDispatchProps, IOwnProps } from './AppDrawer'
import { logout } from '../../services/store/actions/auth/Logout'

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  logout: () => dispatch(logout()),
})

export default connect<{}, IDispatchProps, IOwnProps>(
  null,
  mapDispatchToProps
)(AppDrawer)